const PopBox = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null; 

  return (
    <div className="popbox-overlay">
      <div className="popbox-content"  >
        <div className="popbox-header">
          <h5 className="m-0" style={{color:'#823455'}}> {title}</h5>
          <button className="popbox-close" onClick={onClose}>
          </button>
        </div>
        <div className="popbox-body">{children}</div>
      </div>
    </div>
  );
};

export default PopBox;
